export default "__VITE_ASSET__DkgqMQTj__"